import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Instagram, Facebook, ArrowRight } from 'lucide-react';
import { COMPANY, FORMSUBMIT_URL } from '../data/site';

const QUICK = [
  { label: 'Home', to: '/' }, { label: 'About Us', to: '/about' }, { label: 'Projects', to: '/projects' },
  { label: 'Gallery', to: '/gallery' }, { label: 'CSR Activities', to: '/social-works' }, { label: 'Why Choose Us', to: '/why-choose-us' },
  { label: 'About Developer', to: '/about-developer' }, { label: 'Enquiry', to: '/enquiry' }, { label: 'Contact', to: '/contact' },
];
const SERVICE_LINKS = ['Plotting Development', 'Apartment Development', 'Villa Development', 'Interior Design', 'Building Materials', 'Government Contracts'];

const SOCIALS = [
  { icon: Instagram, href: 'https://www.instagram.com/prakrutihome/', label: 'Instagram', testid: 'footer-social-instagram' },
  { icon: Facebook, href: 'https://www.facebook.com/profile.php?id=61562258242703', label: 'Facebook', testid: 'footer-social-facebook' },
];

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      await fetch(FORMSUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ _subject: 'Newsletter Subscription — PRAKRUTI', email }),
      });
    } catch (_) { /* formsubmit best-effort */ }
    setSent(true);
    setEmail('');
  };

  return (
    <footer data-testid="site-footer" className="bg-bark text-sand/80">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-14">
        <div>
          <div className="mb-6">
            <img src="/assets/prakruti-logo.png" alt="PRAKRUTI Developer — Lead A Better Future" className="h-14 w-auto" />
          </div>
          <p className="text-sm leading-relaxed text-sand/60">{COMPANY.blurb}</p>
          <p className="mt-4 font-serif italic text-sm text-terra/90">{COMPANY.tagline}</p>
          <div className="flex gap-3 mt-7">
            {SOCIALS.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" data-testid={s.testid} aria-label={s.label}
                className="w-9 h-9 border border-sand/20 flex items-center justify-center text-sand/70 hover:bg-terra hover:border-terra hover:text-white transition-colors duration-300">
                <s.icon size={15} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-[11px] font-medium tracking-[0.24em] text-sand/40 mb-6">QUICK LINKS</h4>
          <ul className="space-y-3">
            {QUICK.map((l) => (
              <li key={l.label}>
                <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, '-')}`}
                  className="text-sm text-sand/70 hover:text-terra transition-colors duration-200">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] font-medium tracking-[0.24em] text-sand/40 mb-6">SERVICES</h4>
          <ul className="space-y-3">
            {SERVICE_LINKS.map((s) => (
              <li key={s}>
                <Link to="/services" data-testid={`footer-service-${s.toLowerCase().replace(/\s/g, '-')}`}
                  className="text-sm text-sand/70 hover:text-terra transition-colors duration-200">{s}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] font-medium tracking-[0.24em] text-sand/40 mb-6">CONTACT</h4>
          <ul className="space-y-4 text-sm text-sand/70">
            <li className="flex gap-3"><MapPin size={15} className="text-terra shrink-0 mt-0.5" /> {COMPANY.address}</li>
            <li className="flex gap-3"><Phone size={15} className="text-terra shrink-0 mt-0.5" /> {COMPANY.phone}</li>
            <li className="flex gap-3"><Mail size={15} className="text-terra shrink-0 mt-0.5" /> {COMPANY.email}</li>
            <li className="flex gap-3" data-testid="footer-timings"><Clock size={15} className="text-terra shrink-0 mt-0.5" /> Office Timings: {COMPANY.hours}</li>
          </ul>
          <form onSubmit={subscribe} className="mt-8" data-testid="footer-newsletter-form">
            <p className="text-[11px] tracking-[0.2em] text-sand/40 mb-3">NEWSLETTER</p>
            {sent ? (
              <p className="text-sm text-terra" data-testid="newsletter-success">Subscribed. Welcome to the green side.</p>
            ) : (
              <div className="flex border border-sand/25">
                <input
                  type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email" data-testid="newsletter-email-input"
                  className="bg-transparent text-sm px-4 py-3 w-full outline-none placeholder:text-sand/40 text-sand"
                />
                <button type="submit" data-testid="newsletter-submit-btn" aria-label="Subscribe"
                  className="bg-terra text-white px-4 hover:bg-moss transition-colors duration-300">
                  <ArrowRight size={16} />
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
      <div className="border-t border-sand/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-sand/40 tracking-wider">
          <span data-testid="footer-copyright">© 2026 PRAKRUTI HOMES. ALL RIGHTS RESERVED.</span>
          <span>LEAD A BETTER FUTURE</span>
        </div>
      </div>
    </footer>
  );
};
